/*jshint esversion: 11 */
import React, { useState, useEffect, useMemo } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Table,
  Label,
  FormGroup,
  Button,
  Badge,
  ModalHeader,
  ModalBody,
  Modal,
  ModalFooter,
  Alert,
  Input
} from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { connect } from 'react-redux';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import PageDataLoader from '../Utility/PageDataLoader';
import Paginator from '../Utility/Paginator';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { getStaffList } from '../../api/staff';
import { attendanceStatusOptions } from '../../helpers/attendance';
import { stringify as QStringify, parse as QParse } from 'qs';
import { useHistory } from 'react-router-dom';
import CreateAttendanceModal from './CreateAttendanceModal';
import {
  getAttendanceInfo,
  getAttendanceList,
  getLeaveBalance
} from '../../api/attendance';
import ViewAttendanceModal from './ViewAttendanceModal';
import UpdateAttendanceModal from './UpdateAttendanceModal';
import DeleteAttendanceModal from './DeleteAttendanceModal';
import CancelAttendanceModal from './CancelAttendanceModal';
import CancelRequestModal from './CancelRequestModal';
import LeaveDetailTable from './LeaveDetailTable';
import _ from 'lodash';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { validatePermissionKey } from '../../helpers/permission';
import {
  CANCEL_ATTENDANCE,
  CREATE_ATTENDANCE,
  DELETE_ATTENDANCE,
  UPDATE_ATTENDANCE
} from '../Utility/PermissionKeys';

const animatedComponents = makeAnimated();

const leaveTypeOptions = [
  { value: 'Paid Leave', label: 'Paid Leave' },
  { value: 'Saturday Leave', label: 'Saturday Leave' },
  { value: 'Unpaid Leave', label: 'Unpaid Leave' }
];

const AttendanceListPage = ({ authUser }) => {
  const history = useHistory();

  const [breadcrumbItems] = useState([{ title: 'Attendance', link: '#' }]);
  const [attendanceListLoading, setAttendanceListLoading] = useState(true);
  const [attendanceList, setAttendanceList] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageLimit: 10,
    totalEntries: 0,
    totalPages: 0
  });
  const [filterError, setFilterError] = useState(false);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [currentFilterCount, setCurrentFilterCount] = useState(0);
  const [currentCancelCount, setCurrentCancelCount] = useState(0);
  const [addAModalOpen, setAddAttendanceModalOpen] = useState(false);
  const [attendanceInfo, setAttendanceInfo] = useState({});
  const [attendanceInfoLoading, setAttendanceInfoLoading] = useState(false);
  const [attendanceInfoModalOpen, setAttendanceInfoModalOpen] = useState(false);
  const [updateAttendanceModalOpen, setUpdateAttendanceModalOpen] =
    useState(false);
  const [cancelAttendanceModalOpen, setCancelAttendanceModalOpen] =
    useState(false);
  const [cancelRequestModalOpen, setCancelRequestModalOpen] = useState(false);
  const [deleteAttendanceModalOpen, setDeleteAttendanceModalOpen] =
    useState(false);
  const [expectedDateFilter, setExpectedDateFilter] = useState({
    startDate: null,
    endDate: null
  });
  const [staffQueryId, setStaffQueryId] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [selectedStaffOption, setSelectedStaffOption] = useState([]);
  const [filterStatus, setFilterStatus] = useState(null);
  const [filterLeaveType, setFilterLeaveType] = useState(null);
  const [attendanceId, setAttendanceId] = useState(null);
  const [isDeleted, setIsDeleted] = useState(false);
  const [isConsumed, setIsConsumed] = useState(false);
  const [isCancelled, setIsCancelled] = useState(false);

  const [leaveBalance, setLeaveBalance] = useState({
    paid: { total: 0, consumed: 0, requested: 0, available: 0 },
    saturday: { used: 0, requested: 0, available: 0 },
    unpaid: { consumed: 0, requested: 0 }
  });

  async function fetchLeaveBalance() {
    const response = await getLeaveBalance();
    if (!response) return;

    setLeaveBalance({
      paid: {
        total: response.paid_limit_per_year,
        consumed: response.paid_consumed,
        requested: response.paid_requested,
        available: response.paid_available
      },
      saturday: {
        used: response.saturday_used,
        requested: response.saturday_requested,
        available: response.saturday_available
      },
      unpaid: {
        consumed: response.unpaid_consumed,
        requested: response.unpaid_requested
      }
    });
  }

  const staffOptions = useMemo(
    () => buildStaffOptions(staffList),
    // eslint-disable-next-line
    [staffList]
  );

  let listElem = document.getElementById('attendanceList');
  let linkElem = document.getElementById('attendanceLink');

  useEffect(() => {
    if (listElem) listElem.classList.add('mm-active');
    if (linkElem) linkElem.classList.add('active');
    if (authUser) {
      populateSearchOptions(history?.location?.search);
      fetchStaffList();
      fetchLeaveBalance();
    }
    // eslint-disable-next-line
  }, [authUser, listElem, linkElem]);

  const handlePagination = (page) => {
    fetchData(page, pagination.pageLimit, createQueryOptions());
  };

  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 100
    })
  };

  const fetchData = async (
    current_page = 1,
    page_limit = 10,
    filter = null,
    queryOptions = {}
  ) => {
    setAttendanceListLoading(true);
    const response = await getAttendanceList(
      current_page,
      page_limit,
      filter,
      queryOptions
    );
    if (response) {
      setPagination({
        currentPage: response.metadata.page,
        pageLimit: response.metadata.limit,
        totalPages: response.metadata.total_pages,
        totalEntries: response.metadata.total_results
      });
      setAttendanceList(response.data);
      setAttendanceListLoading(false);
    }
  };

  /**
   *
   * @param {string} searchQuery
   */
  function populateSearchOptions(searchQuery) {
    const parsedQuery = QParse(searchQuery.substring(1));
    if (parsedQuery.startDate) {
      setExpectedDateFilter((pv) => {
        return {
          ...pv,
          startDate: new Date(parsedQuery.startDate)
        };
      });
    }
    if (parsedQuery.endDate) {
      setExpectedDateFilter((pv) => {
        return {
          ...pv,
          endDate: new Date(parsedQuery.endDate)
        };
      });
    }
    if (parsedQuery.status) {
      const selectedStatus = attendanceStatusOptions.filter(
        (i) => i.value === parsedQuery.status
      );
      setFilterStatus(selectedStatus || null);
    }
    if (parsedQuery.filter_type) {
      const selectedType = leaveTypeOptions.filter(
        (i) => i.value === parsedQuery.filter_type
      );
      setFilterLeaveType(selectedType || null);
    }
    if (parsedQuery.filter_user_id) {
      const staffId = parsedQuery.filter_user_id
        .split(',')
        .map((i) => i.trim());
      setStaffQueryId(staffId);
    }

    //setIsDeleted(parsedQuery.isDeleted);

    fetchData(1, pagination.pageLimit || 10, parsedQuery);
    updateFilterCount(parsedQuery);
  }

  function createQueryOptions(
    startDate = expectedDateFilter.startDate,
    endDate = expectedDateFilter.endDate,
    staff = selectedStaffOption,
    status = filterStatus,
    leaveType = filterLeaveType,
    filterDeleted = isDeleted,
    filterConsumed = isConsumed,
    filterCancelled = isCancelled
  ) {
    setFilterError(false);

    if ((startDate && !endDate) || (!startDate && endDate)) {
      setFilterError('Select valid date range');
      return;
    }

    const startDateISOString = startDate
      ? new Date(startDate).toISOString()
      : '';
    const endDateISOString = endDate ? new Date(endDate).toISOString() : '';

    const filterUserId = Array.isArray(staff)
      ? staff.map((i) => i.value._id).join(',')
      : '';

    const attendanceFilterStatus = status ? status.value : '';
    const attendanceFilterLeaveType = leaveType ? leaveType.value : '';

    const queryOptions = {
      start_date: startDateISOString,
      end_date: endDateISOString,
      filter_user_id: filterUserId,
      filter_status: attendanceFilterStatus,
      filter_type: attendanceFilterLeaveType,
      filter_deleted: filterDeleted,
      isConsumed: filterConsumed,
      isCancelled: filterCancelled
    };

    updateUrlPath(queryOptions);
    updateFilterCount(queryOptions);

    return queryOptions;
  }

  function updateUrlPath(queryOptions) {
    const queryString = QStringify(queryOptions);
    history.replace(`/attendance?${queryString}`);
  }

  async function fetchStaffList() {
    const response = await getStaffList(1, 100);
    if (response) {
      setStaffList(response.data);
    }
  }

  function openAddAttendanceModal() {
    setAddAttendanceModalOpen(true);
  }

  function closeAddAttendanceModal() {
    setAddAttendanceModalOpen(false);
  }

  function openAttendanceInfoModal(roleId) {
    fetchAttendanceInfo(roleId);
    setAttendanceInfoModalOpen(true);
  }

  function closeAttendanceInfoModal() {
    setAttendanceInfoModalOpen(false);
  }

  function closeUpdateAttendanceModal() {
    setUpdateAttendanceModalOpen(false);
  }

  function openCancelAttendanceModal(attendanceId) {
    setAttendanceId(attendanceId);
    setCancelAttendanceModalOpen(true);
  }

  function closeCancelAttendanceModal() {
    setCancelAttendanceModalOpen(false);
  }

  function openCancelRequestModal() {
    setCancelRequestModalOpen(true);
  }

  function closeCancelRequestModal() {
    setCancelRequestModalOpen(false);
  }

  async function openUpdateAttendanceModal(attendanceId) {
    fetchAttendanceInfo(attendanceId);
    setUpdateAttendanceModalOpen(true);
  }

  async function openDeleteAttendanceModal(attendanceId, requestType) {
    await fetchAttendanceInfo(attendanceId);
    setAttendanceId({
      attendanceId,
      requestType
    });
    setDeleteAttendanceModalOpen(true);
  }

  function closeDeleteAttendanceModal() {
    setDeleteAttendanceModalOpen(false);
  }

  function resetFields() {
    setIsDeleted(false);
    setIsConsumed(false);
    setIsCancelled(false);
    setSelectedStaffOption([]);
    setExpectedDateFilter({
      startDate: null,
      endDate: null
    });
    setFilterStatus(null);
    setFilterLeaveType(null);
  }

  async function fetchAttendanceInfo(attendanceId) {
    setAttendanceInfoLoading(true);
    const response = await getAttendanceInfo(attendanceId);
    if (response) {
      setAttendanceInfo(response);
      setAttendanceInfoLoading(false);
    }
  }

  function openFilterModal() {
    setFilterModalOpen(true);
  }

  function closeFilterModal() {
    setFilterModalOpen(false);
  }

  function updateFilterCount(option) {
    let count = 0;
    Object.keys(option).forEach((i) => {
      const value = option[i];
      // Skip empty, null, undefined values
      if (value === undefined || value === null || value === '') {
        return;
      }
      // Skip boolean false and string "false"
      if (value === false || value === 'false') {
        return;
      }
      // Count filter as active
      count += 1;
    });
    setCurrentFilterCount(count);
  }

  /**
   *
   * @param {array<date>} dates
   */
  function dateRangeHandler(dates) {
    const [start, end] = dates;
    setExpectedDateFilter({
      startDate: start,
      endDate: end
    });
  }

  /**
   *
   * @param {array<object>} staffArray
   * @returns
   */
  function buildStaffOptions(staffArray) {
    const staffOptions = staffArray.map((i) => {
      return {
        label: `${i.name} - ${i.role?.role_name}`,
        value: i
      };
    });
    const selectedStaff = staffOptions.filter((i) =>
      staffQueryId.includes(i.value._id)
    );
    setSelectedStaffOption(selectedStaff);
    return staffOptions;
  }

  const isDatePassed = (endDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const leaveEnd = new Date(endDate);
    leaveEnd.setHours(0, 0, 0, 0);

    return leaveEnd < today;
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Modal isOpen={filterModalOpen} backdrop="static" size="md">
          <ModalHeader toggle={closeFilterModal}>Filter Attendance</ModalHeader>
          <AvForm
            className="needs-validation"
            onValidSubmit={async () => {
              let options = await createQueryOptions();
              if (options) {
                await fetchData(1, pagination.pageLimit, options);
                closeFilterModal();
              }
            }}
          >
            <ModalBody>
              {filterError ? (
                <Alert
                  color="danger"
                  role="alert"
                  isOpen={filterError ? true : false}
                  toggle={() => setFilterError(false)}
                >
                  <i className="mdi mdi-block-helper mr-2"></i>
                  {filterError}
                </Alert>
              ) : null}
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>Start Date</Label>
                    <DatePicker
                      selected={expectedDateFilter.startDate}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                      onChange={(date) =>
                        setExpectedDateFilter((pv) => ({
                          ...pv,
                          startDate: date
                        }))
                      }
                      isClearable={true}
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>End Date</Label>
                    <DatePicker
                      selected={expectedDateFilter.endDate}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                      onChange={(date) =>
                        setExpectedDateFilter((pv) => ({
                          ...pv,
                          endDate: date
                        }))
                      }
                      isClearable={true}
                    />
                  </FormGroup>
                </Col>
                {authUser && authUser.user_type === 'super_admin' && (
                  <Col md="12">
                    <FormGroup>
                      <Label>Select Staff</Label>
                      <Select
                        components={animatedComponents}
                        options={staffOptions}
                        onChange={(e) => setSelectedStaffOption(e)}
                        value={selectedStaffOption}
                        isClearable={true}
                        isMulti
                        styles={selectStyles}
                      />
                    </FormGroup>
                  </Col>
                )}
                <Col md="12">
                  <FormGroup>
                    <Label>Status</Label>
                    <Select
                      components={animatedComponents}
                      options={attendanceStatusOptions}
                      onChange={(e) => setFilterStatus(e)}
                      value={filterStatus}
                      isClearable={true}
                      styles={selectStyles}
                    />
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup>
                    <Label>Leave Type</Label>
                    <Select
                      components={animatedComponents}
                      options={leaveTypeOptions}
                      onChange={(e) => setFilterLeaveType(e)}
                      value={filterLeaveType}
                      isClearable={true}
                      styles={selectStyles}
                    />
                  </FormGroup>
                </Col>
                {authUser && authUser.user_type === 'super_admin' && (
                  <Col md="12">
                    <FormGroup>
                      <Label>Is Deleted</Label>
                      <div
                        className="custom-control custom-switch mb-2"
                        dir="ltr"
                      >
                        <Input
                          id="deleteCustomSwitch"
                          type="checkbox"
                          className="custom-control-input p-3"
                          checked={isDeleted}
                          onChange={(e) => setIsDeleted(e.target.checked)}
                        />
                        <Label
                          htmlFor="deleteCustomSwitch"
                          className="custom-control-label"
                        >
                          Deleted Tasks
                        </Label>
                      </div>
                    </FormGroup>
                  </Col>
                )}
                <Col md="12">
                  <FormGroup>
                    <Label>Is Consumed</Label>
                    <div
                      className="custom-control custom-switch mb-2"
                      dir="ltr"
                    >
                      <Input
                        id="consumedCustomSwitch"
                        type="checkbox"
                        className="custom-control-input p-3"
                        checked={isConsumed}
                        onChange={(e) => setIsConsumed(e.target.checked)}
                      />
                      <Label
                        htmlFor="consumedCustomSwitch"
                        className="custom-control-label"
                      >
                        Consumed Tasks
                      </Label>
                    </div>
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup>
                    <Label>Is Cancelled</Label>
                    <div
                      className="custom-control custom-switch mb-2"
                      dir="ltr"
                    >
                      <Input
                        id="cancelledCustomSwitch"
                        type="checkbox"
                        className="custom-control-input p-3"
                        checked={isCancelled}
                        onChange={(e) => setIsCancelled(e.target.checked)}
                      />
                      <Label
                        htmlFor="cancelledCustomSwitch"
                        className="custom-control-label"
                      >
                        Cancelled Tasks
                      </Label>
                    </div>
                  </FormGroup>
                </Col>
              </Row>
              <Row className="d-flex px-3" style={{ height: '100%' }}></Row>
            </ModalBody>
            <ModalFooter>
              <Button size="sm" type="submit" color="primary">
                Apply Filter
              </Button>
              <Button
                size="sm"
                type="button"
                color="success"
                onClick={async () => {
                  await resetFields();
                  let options = await createQueryOptions(
                    null,
                    null,
                    null,
                    null,
                    null,
                    false,
                    false,
                    false
                  );
                  if (options) {
                    await fetchData(1, pagination.pageLimit, options);
                    closeFilterModal();
                  }
                }}
              >
                Reset
              </Button>
              <Button
                size="sm"
                type="button"
                color="light"
                onClick={closeFilterModal}
              >
                Close
              </Button>
            </ModalFooter>
          </AvForm>
        </Modal>
        <CreateAttendanceModal
          modalOpenState={addAModalOpen}
          closeModalHandler={closeAddAttendanceModal}
          fetchNewAttendanceList={async () => {
            let options = await createQueryOptions();
            if (options) {
              await fetchData(1, null, options);
            }
          }}
          authUser={authUser}
          setLeaveBalance={setLeaveBalance}
          leaveBalance={leaveBalance}
        />
        <ViewAttendanceModal
          modalOpenState={attendanceInfoModalOpen}
          closeModalHandler={closeAttendanceInfoModal}
          attendanceInfo={attendanceInfo}
          attendanceInfoLoading={attendanceInfoLoading}
          authUser={authUser}
        />
        <UpdateAttendanceModal
          modalOpenState={updateAttendanceModalOpen}
          closeModalHandler={closeUpdateAttendanceModal}
          attendanceInfo={attendanceInfo}
          attendanceInfoLoading={attendanceInfoLoading}
          fetchNewAttendanceList={async () => {
            let options = await createQueryOptions();
            if (options) {
              await fetchData(1, null, options);
            }
          }}
          authUser={authUser}
          setLeaveBalance={setLeaveBalance}
        />
        <CancelAttendanceModal
          modalOpenState={cancelAttendanceModalOpen}
          closeModalHandler={closeCancelAttendanceModal}
          attendanceId={attendanceId}
          fetchNewData={async () => {
            let options = await createQueryOptions();
            if (options) {
              await fetchData(1, null, options);
            }
          }}
          setCurrentCancelCount={setCurrentCancelCount}
        />
        <CancelRequestModal
          modalOpenState={cancelRequestModalOpen}
          closeModalHandler={closeCancelRequestModal}
          attendanceList={attendanceList}
          fetchNewData={async () => {
            let options = await createQueryOptions();
            if (options) await fetchData(1, null, options);
          }}
          setCurrentCancelCount={setCurrentCancelCount}
        />
        <DeleteAttendanceModal
          modalOpenState={deleteAttendanceModalOpen}
          closeModalHandler={closeDeleteAttendanceModal}
          attendanceId={attendanceId?.attendanceId}
          type={attendanceId?.requestType}
          fetchNewData={async () => {
            let options = await createQueryOptions();
            if (options) {
              await fetchData(1, null, options);
            }
          }}
          attendanceInfo={attendanceInfo}
          setLeaveBalance={setLeaveBalance}
        />
        <Container fluid>
          <Breadcrumbs
            title="View Attendance"
            breadcrumbItems={breadcrumbItems}
          />
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <>
                    <Row>
                      <Col className="d-flex justify-content-end align-items-center">
                        <Button
                          size="sm"
                          color="primary"
                          className=" waves-effect waves-light mr-3"
                          onClick={openFilterModal}
                        >
                          <i className="ri-filter-fill align-middle mr-2"></i>
                          <span>Filter Attendance</span>
                          {currentFilterCount > 0 && (
                            <Badge color="light" pill className="ml-2">
                              {currentFilterCount}
                            </Badge>
                          )}
                        </Button>
                        {authUser?.user_type === 'super_admin' && (
                          <Button
                            size="sm"
                            color="warning"
                            className="waves-effect waves-light mr-3"
                            onClick={openCancelRequestModal}
                          >
                            Cancel Requests
                            {currentCancelCount > 0 && (
                              <Badge color="light" pill className="ml-2">
                                {currentCancelCount}
                              </Badge>
                            )}
                          </Button>
                        )}
                        {authUser &&
                          validatePermissionKey(authUser, CREATE_ATTENDANCE) &&
                          authUser.user_type === 'staff' && (
                            <Button
                              size="sm"
                              color="success"
                              className=" waves-effect waves-light"
                              onClick={openAddAttendanceModal}
                            >
                              <i className="ri-add-line align-middle mr-2"></i>
                              Add Attendance
                            </Button>
                          )}
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col md="2">
                        <FormGroup>
                          <Label>Show Entries</Label>
                          <select
                            className="form-control"
                            onChange={async (e) => {
                              const newPageLimit = parseInt(e.target.value, 10);
                              const options = createQueryOptions();
                              if (options) {
                                await fetchData(1, newPageLimit, options);
                              } else {
                                await fetchData(1, newPageLimit);
                              }
                              setPagination({
                                currentPage: 1,
                                pageLimit: newPageLimit,
                                totalEntries: 0,
                                totalPages: 0
                              });
                            }}
                            value={pagination.pageLimit}
                            disabled={attendanceListLoading}
                          >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>
                        </FormGroup>
                      </Col>
                      {authUser?.user_type === 'staff' && (
                        <Col md="10" className="d-flex justify-content-end">
                          <LeaveDetailTable
                            leaveBalance={leaveBalance}
                          />
                        </Col>
                      )}
                    </Row>
                    {attendanceListLoading ? (
                      <div className="text-center">
                        <PageDataLoader />
                      </div>
                    ) : (
                      <div className="table-rep-plugin">
                        <div
                          className="table-responsive mb-0"
                          data-pattern="priority-columns"
                        >
                          <Table
                            id="tech-companies-1"
                            striped
                            bordered
                            responsive
                          >
                            <thead>
                              <tr>
                                <th>SL. No</th>
                                {authUser?.user_type === 'super_admin' && (
                                  <th>Staff Name</th>
                                )}
                                <th>Reason</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Days</th>
                                <th>Status</th>
                                <th>Remarks</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {attendanceList?.map((item, index) => (
                                <tr key={index}>
                                  <th>{index + 1}</th>
                                  {authUser?.user_type === 'super_admin' && (
                                    <td>
                                      <Link to={`/staff`}>
                                        {(item.staff_id?.name || '-') +
                                          (item.staff_id?.role?.role_name
                                            ? ` [${_.upperCase(
                                                item.staff_id.role.role_name
                                              )}]`
                                            : '')}
                                      </Link>
                                    </td>
                                  )}
                                  <td>{item.leave_reason}</td>

                                  <td>
                                    {moment(new Date(item.start_date)).format(
                                      'DD-MM-YYYY'
                                    )}
                                  </td>
                                  <td>
                                    {moment(new Date(item.end_date)).format(
                                      'DD-MM-YYYY'
                                    )}
                                  </td>
                                  <td>
                                    {Math.floor(
                                      (new Date(item.end_date) -
                                        new Date(item.start_date)) /
                                        (1000 * 60 * 60 * 24)
                                    ) + 1}
                                  </td>
                                  <td>
                                    <Badge
                                      className="p-2"
                                      color={
                                        item.cancel_requested_at &&
                                        item.cancel_action === 'Pending'
                                          ? 'info' // Cancel Requested
                                          : item.cancel_requested_at &&
                                              item.cancel_action === 'Approved'
                                            ? 'secondary' // Cancelled
                                            : item.isConsumed
                                              ? 'warning' // Consumed
                                              : item.status === 'Applied'
                                                ? 'primary' // Applied
                                                : item.status === 'Approved'
                                                  ? 'success' // Approved
                                                  : item.status === 'Rejected'
                                                    ? 'danger' // Rejected
                                                    : 'dark' // fallback
                                      }
                                      pill
                                    >
                                      {item.cancel_requested_at &&
                                      item.cancel_action === 'Pending'
                                        ? 'Cancel Requested'
                                        : item.cancel_requested_at &&
                                            item.cancel_action === 'Approved'
                                          ? 'Cancelled'
                                          : item.isConsumed
                                            ? 'Consumed'
                                            : item.status}
                                    </Badge>
                                  </td>
                                  <td>{item.remarks || '-'}</td>
                                  <td>
                                    {/* VIEW → always */}
                                    <Button
                                      size="sm"
                                      color="primary"
                                      className="mr-2 mb-2"
                                      onClick={() =>
                                        openAttendanceInfoModal(item._id)
                                      }
                                    >
                                      <i className="fas fa-eye mr-2"></i>
                                      View
                                    </Button>
                                    {/* EDIT → STAFF can edit only when Applied */}
                                    {validatePermissionKey(
                                      authUser,
                                      UPDATE_ATTENDANCE
                                    ) &&
                                      authUser?.user_type === 'staff' &&
                                      item.status === 'Applied' &&
                                      !item.isDeleted &&
                                      !isDatePassed(item.end_date)  && (
                                        <Button
                                          size="sm"
                                          color="warning"
                                          className="mr-2 mb-2"
                                          onClick={() =>
                                            openUpdateAttendanceModal(item._id)
                                          }
                                        >
                                          <i className="fas fa-edit mr-2"></i>
                                          Edit
                                        </Button>
                                      )}
                                    {/* EDIT → ADMIN can edit when Applied, Approved, Rejected and NOT cancelled or consumed */}
                                    {authUser?.user_type === 'super_admin' &&
                                      !item.isDeleted &&
                                      !item.isConsumed &&
                                      item.cancel_action !== 'Approved'  &&
                                      !isDatePassed(item.end_date) &&
                                      [
                                        'Applied',
                                        'Approved',
                                        'Rejected'
                                      ].includes(item.status) && (
                                        <Button
                                          size="sm"
                                          color="warning"
                                          className="mr-2 mb-2"
                                          onClick={() =>
                                            openUpdateAttendanceModal(item._id)
                                          }
                                        >
                                          <i className="fas fa-edit mr-2"></i>
                                          Edit
                                        </Button>
                                      )}
                                    {/* STAFF CANCEL REQUEST → only when Approved */}
                                    {validatePermissionKey(
                                      authUser,
                                      CANCEL_ATTENDANCE
                                    ) &&
                                      authUser?.user_type === 'staff' &&
                                      item.status === 'Approved' &&
                                      !item.isConsumed &&
                                      item.cancel_action !== 'Approved' &&
                                      !item.cancel_requested_at &&
                                      !item.isDeleted && (
                                        <Button
                                          size="sm"
                                          color="warning"
                                          className="mr-2 mb-2"
                                          onClick={() =>
                                            openCancelAttendanceModal(item._id)
                                          }
                                        >
                                          <i className="fas fa-times mr-2"></i>
                                          Cancel
                                        </Button>
                                      )}
                                    {/* DELETE → only when Applied and staff only */}
                                    {validatePermissionKey(
                                      authUser,
                                      DELETE_ATTENDANCE
                                    ) &&
                                      authUser?.user_type === 'staff' &&
                                      item.status === 'Applied' &&
                                      !item.isDeleted && (
                                        <Button
                                          size="sm"
                                          color="danger"
                                          className="mr-2 mb-2"
                                          onClick={() =>
                                            openDeleteAttendanceModal(
                                              item._id,
                                              'delete'
                                            )
                                          }
                                        >
                                          <i className="fas fa-trash mr-2"></i>
                                          Delete
                                        </Button>
                                      )}
                                    {/* RESTORE */}
                                    {item.isDeleted && (
                                      <Button
                                        size="sm"
                                        color="secondary"
                                        className="mr-2 mb-2"
                                        onClick={() =>
                                          openDeleteAttendanceModal(
                                            item._id,
                                            'restore'
                                          )
                                        }
                                      >
                                        <i className="fas fa-trash-restore mr-2"></i>
                                        Restore
                                      </Button>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    )}
                    <Row className="mt-2">
                      <Col md="5">
                        <p>
                          <strong>
                            {' '}
                            Showing{' '}
                            {(pagination.currentPage - 1) *
                              pagination.pageLimit +
                              1}{' '}
                            to{' '}
                            {Math.min(
                              pagination.currentPage * pagination.pageLimit,
                              pagination.totalEntries
                            )}{' '}
                            of {pagination.totalEntries} entries
                          </strong>
                        </p>
                      </Col>
                      {!attendanceListLoading && attendanceList.length > 0 && (
                        <Col md="7">
                          <Paginator
                            totalPages={pagination.totalPages}
                            currentPage={pagination.currentPage}
                            changePage={handlePagination}
                          />
                        </Col>
                      )}
                    </Row>
                  </>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(AttendanceListPage);
